export default {
  SET_INTERCOM(state, payload) {
    state.intercom = payload
  },
}
